module.exports = {"652722100":"精河镇","652722101":"大河沿子镇","652722102":"托里镇","652722103":"托托镇","652722200":"茫丁乡","652722400":"阿合其农场","652722401":"八家户农场","652722402":"精河工业园区","652722503":"兵团八十三团","652722504":"兵团九十一团"}


//////////////////
// WEBPACK FOOTER
// ./src/town/652722.json
// module id = 2864
// module chunks = 0